import React from 'react';
import PropTypes from 'prop-types';

function AlumnaTag({ name, post }) {
  return (
    <div className="absolute bottom-0 left-0 right-0 p-4">
      <div className="w-6 h-[3px] bg-primary rounded-full mb-1.5" />
      <h3 className="text-white font-title font-bold text-sm leading-tight">
        {name}
        <span className="ml-1.5 text-primary/90 font-light italic text-xs">Alumna</span>
      </h3>
      <p className="text-white/70 text-[11px] mt-0.5">{post}</p>
    </div>
  );
}

AlumnaTag.propTypes = {
  name: PropTypes.string.isRequired,
  post: PropTypes.string.isRequired
};

export default AlumnaTag;
